import ParametricsWrapper from "@mediline/mediline-api-middleware/src/wrappers/queue.wrapper";
import UserProfileWrapper from "@mediline/mediline-api-middleware/src/wrappers/user.profile.wrapper";
const phw = new ParametricsWrapper();
const upw = new UserProfileWrapper();

//export const getPatientsQueue = async (userToken, specialtyId) => phw.getPatientsQueue(userToken, specialtyId);
export const getPatientsQueue = async (userToken, specialtyId) => upw.getPatientsQueue(userToken, specialtyId);
export const getPatientsQueueOther = async (userToken, specialtyId) => upw.getPatientsQueueOther(userToken, specialtyId);
export const getEstimatedTime = async (userToken, specialtyId, queueId) => phw.getEstimatedTime(userToken, specialtyId, queueId);